import { render, staticRenderFns } from "./Critique.vue?vue&type=template&id=10c48d23&"
import script from "./Critique.vue?vue&type=script&lang=js&"
export * from "./Critique.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports